import React from 'react';
import PropTypes from 'prop-types';

function RadioInputGroup({
  options, handleInputChange, selected, name, className, style, idKey,
}) {
  if (style === 'checkbox') {
    return (
      <div className={`form-group ${className}`}>
        { options.map((option) => (
          <label
            className="custom-checkbox-container"
            htmlFor={`${idKey ? `${idKey}-` : ''}${option.value}`}
            key={option.value}
          >
            <input
              type="checkbox"
              id={`${idKey ? `${idKey}-` : ''}${option.value}`}
              value={option.value}
              name={name}
              checked={selected === option.value}
              onClick={() => handleInputChange(option)}
            />
            <span className="checkmark" />
            <span className="label body-text-2">{option.label}</span>
          </label>
        ))}
      </div>
    );
  }
  return (
    <div className={`form-group g-row--always ${className}`}>
      { options.map((option) => (
        <div className="option me-4" key={option.value}>
          <input
            type="radio"
            id={`${idKey ? `${idKey}-` : ''}${option.value}`}
            value={option.value}
            name={name}
            checked={selected === option.value}
            onChange={() => handleInputChange(option)}
          />
          <label htmlFor={`${idKey ? `${idKey}-` : ''}${option.value}`}>{option.label}</label>
        </div>
      ))}
    </div>
  );
}

RadioInputGroup.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  handleInputChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  selected: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  className: PropTypes.string,
  style: PropTypes.string,
  idKey: PropTypes.string,
};

RadioInputGroup.defaultProps = {
  selected: null,
  className: '',
  style: 'radio',
  idKey: null,
};

export default RadioInputGroup;
